import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-flask',
    templateUrl: './flask.component.html',
    styleUrls: ['./flask.component.css'],
    standalone: false
})
export class FlaskComponent {
  @Input() size=24;
  @Input() color='#000';
}
